import "./LoginPage.css";
import vendorimg from "../../../assets/Component 24.png";
import finkraft from "../../../assets/finkraft.png";
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../firebase'; // adjust as needed
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";
import checkmark from "../../../assets/checkmark.jpg";
import { Eye, EyeOff } from 'lucide-react'; // Optional: use any icon library you prefer
import axios from 'axios';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(true);
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState('');
  const [newpasswordError, setNewPasswordError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [resetEmail, setResetEmail] = useState(''); // Separate state for the second input

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      background: '#fff',
      padding: '30px 40px',
      borderRadius: '12px',
      textAlign: 'center',
      width: '300px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
      fontFamily: 'Arial, sans-serif',
      animation: 'fadeIn 0.3s ease-in-out',
    },
    icon: {
      fontSize: '40px',
      marginBottom: '10px',
      color: 'green',
    },
    message: {
      fontSize: '18px',
      fontWeight: '500',
      marginBottom: '15px',
      color: '#333',
    },
    button: {
      padding: '10px 20px',
      backgroundColor: '#007b8f',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      fontSize: '14px',
      cursor: 'pointer',
    },
  };


  const handleLogin = async () => {
    if (!email || !password) {
      toast.error('Please enter email and password');
      return;
    }

    try {
      // Step 1: Check if user exists
      const checkRes = await fetch("https://vendor-score.finkraftai.com/check-user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const checkData = await checkRes.json();

      if (!checkData.exists) {
        setEmailError('User does not exist. Please register.');
        return;
      }

      // Step 2: Try Firebase login
      await signInWithEmailAndPassword(auth, email, password);
      
      // Step 3: Get JWT token
      const tokenRes = await fetch("https://vendor-score.finkraftai.com/create-token", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        credentials: 'include',
        body: JSON.stringify({ email }),
      });

      const tokenData = await tokenRes.json();
      
      if (tokenData.access_token) {
        // Store token in localStorage
        localStorage.setItem("token", tokenData.access_token);
        localStorage.setItem("email", email);
        navigate('/dashboard');
      } else {
        toast.error('Failed to get authentication token');
      }
    } catch (err) {
      console.error('Login error:', err);
      setPasswordError('Invalid password');
      setShowForgotPassword(true);
    }
  };


  const [resetStep, setResetStep] = useState(1); // Step 1: Enter email, Step 2: Enter new password

  const handleForgotPassword = () => {
    setResetPasswordModal(true);
    setResetStep(1); // Start with the email input step
  };


  const [showUserNotFoundModal, setShowUserNotFoundModal] = useState(false); // State to control the modal visibility


const [otp, setOtp] = useState('');
const [otpError, setOtpError] = useState('');

// ...existing code...

// Handler for Step 1: Send OTP
const handleNextStep = async () => {
  if (!resetEmail) {
    setEmailError("Please enter your email.");
    return;
  }
  try {
    // Check if user exists
    const checkRes = await fetch("https://vendor-score.finkraftai.com/check-user", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: resetEmail }),
    });
    const checkData = await checkRes.json();
    if (!checkData.exists) {
      setShowUserNotFoundModal(true);
      setEmailError("User does not exist.");
      return;
    }
    // Send OTP
    const res = await fetch("https://vendor-score.finkraftai.com/send-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: resetEmail }),
    });
    const data = await res.json();
    if (data.success) {
      toast.success("OTP sent to your email.");
      setResetStep(2);
    } else {
      toast.error(data.error || "Failed to send OTP.");
    }
  } catch (err) {
    toast.error("Something went wrong.");
  }
};

// Handler for Step 2: Verify OTP
const handleVerifyOtp = async () => {
  if (otp.length !== 6) {
    setOtpError("Enter the 6-digit OTP.");
    return;
  }
  try {
    const res = await fetch("https://vendor-score.finkraftai.com/verify-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: resetEmail, otp }),
    });
    const data = await res.json();
    if (data.success) {
      setResetStep(3);
      setOtpError('');
      setEmail('')
      setPassword('')
    } else {
      setOtpError("Invalid OTP.");
    }
  } catch (err) {
    setOtpError("Verification failed.");
  }
};

// Handler for Step 3: Update Password
const handleUpdatePassword = async () => {
  const alphanumericRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;
  if (!alphanumericRegex.test(newPassword)) {
    setNewPasswordError("Password must be at least 6 characters and contain both letters and numbers");
    return;
  }
  try {
    const res = await axios.post("https://vendor-score.finkraftai.com/api/change-password", {
      email: resetEmail,
      newPassword,
    });
    if (res.status === 200) {
      setShowPopup(true);
      setResetPasswordModal(false);
      setResetStep(1);
      setResetEmail('');
      setOtp('');
      setNewPassword('');
      setNewPasswordError('');
    } else {
      setNewPasswordError("Error updating password.");
    }
  } catch (error) {
    setNewPasswordError("Server error: " + error.message);
  }
};
// ...existing code...

  return (
    <div className="login-page-main">
      <ToastContainer position="top-center" autoClose={3000} />
      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.icon}><img src={checkmark} height={50} /></div>
            <div style={styles.message}>Password updated successfully!</div>
            <button style={styles.button} onClick={() => setShowPopup(false)}>
              OK
            </button>
          </div>
        </div>
      )}

      {showUserNotFoundModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)', // Slightly darker overlay
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000, // Higher zIndex than resetPasswordModal
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '30px 40px',
              borderRadius: '12px',
              textAlign: 'center',
              width: '300px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
              fontFamily: 'Arial, sans-serif',
            }}
          >
            <h2 style={{ fontSize: '20px', marginBottom: '15px' }}>
              {emailError === "Invalid email address" ? "Invalid Email" : "User Not Found"}
            </h2>
            <p style={{ fontSize: '14px', marginBottom: '20px', color: '#555' }}>
              {emailError === "Invalid email address"
                ? "The email address you entered is not valid. Please enter a valid email address."
                : "The email address you entered is not registered. Please check your email or sign up for a new account."}
            </p>
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: '#007b8f',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                fontSize: '14px',
                cursor: 'pointer',
              }}
              onClick={() => {
                setShowUserNotFoundModal(false); // Close the modal
                setEmailError(""); // Clear the error message
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
{resetPasswordModal && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: '#fff',
        padding: '30px 40px',
        borderRadius: '12px',
        width: '400px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
      }}
    >
      {resetStep === 1 && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '15px' }}>Password Reset</h2>
          <p style={{ fontSize: '14px', marginBottom: '20px', color: '#555' }}>
            Provide the email address associated with your account to recover your password.
          </p>
          <div style={{ marginBottom: '20px' }}>
            <label
              style={{
                display: 'block',
                fontSize: '14px',
                marginBottom: '5px',
                textAlign: 'left',
              }}
            >
              Email
            </label>
            <input
              type="email"
              placeholder="Enter email address"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '14px',
              }}
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
            />
          </div>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: '#007b8f',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
              marginRight: '10px',
            }}
            onClick={handleNextStep}
          >
            Next
          </button>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: 'gray',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setResetPasswordModal(false);
              setResetEmail('');
              setResetStep(1);
              setOtp('');
              setNewPassword('');
              setNewPasswordError('');
            }}
          >
            Cancel
          </button>
        </>
      )}
      {resetStep === 2 && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '15px' }}>Verify OTP</h2>
          <p style={{ fontSize: '14px', marginBottom: '20px', color: '#555' }}>
            Enter the 6-digit OTP sent to {resetEmail}
          </p>
          <input
            type="text"
            maxLength={6}
            value={otp}
            onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '14px',
              letterSpacing: '8px',
              textAlign: 'center',
              marginBottom: '10px',
            }}
          />
          {otpError && (
            <p style={{ color: 'red', fontSize: '12px', marginBottom: '10px' }}>{otpError}</p>
          )}
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: '#007b8f',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
              marginRight: '10px',
            }}
            onClick={handleVerifyOtp}
          >
            Verify OTP
          </button>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: 'gray',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setResetPasswordModal(false);
              setResetEmail('');
              setResetStep(1);
              setOtp('');
              setNewPassword('');
              setNewPasswordError('');
            }}
          >
            Cancel
          </button>
        </>
      )}
      {resetStep === 3 && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '15px' }}>Reset Your Password</h2>
          <p style={{ fontSize: '14px', marginBottom: '20px', color: '#555' }}>For {resetEmail}</p>
          <div style={{ marginBottom: '20px', position: 'relative' }}>
            <label
              style={{
                display: 'block',
                fontSize: '14px',
                marginBottom: '5px',
                textAlign: 'left',
              }}
            >
              New Password
            </label>
            <input
              type={showNewPassword ? 'text' : 'password'}
              placeholder="Enter new password"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '14px',
              }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <span
              style={{
                position: 'absolute',
                right: '0px',
                top: '70%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#007b8f',
              }}
              onClick={() => setShowNewPassword((prev) => !prev)}
            >
              {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
            {newpasswordError && (
              <p
                className="error-text"
                style={{
                  color: 'red',
                  fontSize: '12px',
                  marginTop: '5px',
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                }}
              >
                {newpasswordError}
              </p>
            )}
          </div>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: '#007b8f',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
              marginRight: '10px',
              marginTop: '20px',
            }}
            onClick={handleUpdatePassword}
          >
            Update
          </button>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: 'gray',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
            onClick={() => setResetPasswordModal(false)}
          >
            Cancel
          </button>
        </>
      )}
    </div>
  </div>
)}

      <div className="login-container111">
        <div className="logo">
          <img src={finkraft} alt="Logo" className="logo-img" />
        </div>

        <div className="login-box">
          <h1 className="welcome-text">Welcome Back</h1>
          <p className="subtext">Login with your Vendor Score account.</p>

          <label className="label">Email Address</label>
          <input
            type="email"
            placeholder="Enter email address"
            className={`input ${emailError ? 'input-error' : ''}`}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setPasswordError('');
            }}
          />
          {emailError && <p className="error-text">{emailError}</p>}

          {/* <label className="label">Password</label>
          <input
            type="password"
            placeholder="Enter password"
            className={`input ${passwordError ? 'input-error' : ''}`}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setShowForgotPassword(false);
              setPasswordError('');
            }}
          />
          {passwordError && <p className="error-text">{passwordError}</p>} */}

          <div className="input-wrapper" style={{ position: 'relative', marginBottom: '20px' }}>
            <label className="label">Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter password"
              className={`input ${passwordError ? 'input-error' : ''}`}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError('');
              }}
              style={{
                width: '100%',
                border: passwordError ? '1px solid red' : '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '14px',
                position: 'relative', // Ensure the input stays in place
              }}
            />
            <span
              className="toggle-password-icon"
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: 'absolute',
                right: '0px',
                top: '55%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#007b8f',
              }}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </span>
            {passwordError && (
              <p
                className="error-text"
                style={{
                  color: 'red',
                  fontSize: '12px',
                  marginTop: '5px',
                  marginBottom: '0', // Prevent extra spacing
                  position: 'absolute', // Keep the error message from affecting layout
                  top: '100%', // Position below the input
                  left: '0',
                }}
              >
                {passwordError}
              </p>
            )}
          </div>





          <div className="remember-row">
            <input type="checkbox" id="remember" className="checkbox" defaultChecked />
            <label htmlFor="remember" style={{ marginTop: '5px' }}>Remember me</label>
          </div>

          <button className="continue-button" onClick={handleLogin}>
            Continue
          </button>

          {showForgotPassword && (
            <div style={{ marginTop: '10px' }}>
              <button onClick={handleForgotPassword} className="forgot-button">
                Forgot Password? Click here to reset.
              </button>
            </div>
          )}

          <p className="signup-text">
            Don't have an account? <Link to='/welcome'>Sign up.</Link>
          </p>
        </div>
      </div>
      <div className="vendor-image-container">
        <img src={vendorimg} className="vendor-image" alt="Vendor visual" />
      </div>
    </div>
  );
};

export default LoginPage;

